import { renderDesktopTable, renderMobileTables } from './Table.helpers';
import useIsMobile from '~/hooks/useIsMobile';

/**
 * Renders a <table> for desktop with as many columns as necessary
 * @param {TableProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Table = ({ tableHead, tableBody, dataId }) => {
  const isMobile = useIsMobile({ contextKey: 'table' });

  if (isMobile) {
    return renderMobileTables({ tableHead, tableBody, dataId });
  }
  return renderDesktopTable({ tableHead, tableBody, dataId });
};

export default Table;
